import { api } from './api';

export type DemoRequestStatus = 'new' | 'contacted' | 'scheduled' | 'completed' | 'archived';

export interface DemoRequestItem {
  id: number;
  email: string;
  name: string;
  organization: string;
  role: string;
  organization_size: string;
  interests: string[];
  notes: string | null;
  status: DemoRequestStatus;
  created_at: string;
  updated_at: string | null;
}

export interface DemoRequestStats {
  total: number;
  new: number;
  contacted: number;
  scheduled: number;
  completed: number;
  archived: number;
}

export interface DemoRequestListResponse {
  items: DemoRequestItem[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
  stats: DemoRequestStats;
}

export interface DemoRequestFilterParams {
  page?: number;
  per_page?: number;
  status?: string;
  search?: string;
}

class DemoRequestService {
  private baseUrl = '/v1/admin/demo-requests';

  async getDemoRequests(params: DemoRequestFilterParams = {}): Promise<DemoRequestListResponse> {
    const cleanParams: Record<string, string | number> = {};
    if (params.page) cleanParams.page = params.page;
    if (params.per_page) cleanParams.per_page = params.per_page;
    if (params.status && params.status !== 'all') cleanParams.status = params.status;
    if (params.search && params.search.trim()) cleanParams.search = params.search.trim();

    const response = await api.get<DemoRequestListResponse>(this.baseUrl, { params: cleanParams });
    return response.data;
  }

  async updateStatus(id: number, status: DemoRequestStatus): Promise<DemoRequestItem> {
    const response = await api.patch<DemoRequestItem>(`${this.baseUrl}/${id}/status`, { status });
    return response.data;
  }

  async downloadCsv(status?: string, search?: string): Promise<void> {
    const cleanParams: Record<string, string> = {};
    if (status && status !== 'all') cleanParams.status = status;
    if (search && search.trim()) cleanParams.search = search.trim();

    const response = await api.get(`${this.baseUrl}/export`, {
      params: cleanParams,
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `flash_prepared_demo_requests_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}

export const demoRequestService = new DemoRequestService();
